export const isOnSale = variants =>
  !!variants.find(
    ({ compareAtPrice, price }) =>
      compareAtPrice !== null && parseFloat(price) < parseFloat(compareAtPrice)
  );
